import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-sixteen',
  templateUrl: './home-sixteen.component.html',
  styleUrls: ['./home-sixteen.component.scss']
})
export class HomeSixteenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
